module.exports = __webpack_public_path__ + "static/media/maginno.557acbe5.png";